import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import { FAQS, TERMS_AND_CONDITION } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import OrderSummaryBackgroundImage from "public/images/oregon/oregon_banner.png";

export const oregon_fanpass: TTeamConfig = {
  TEAM_SCHEMA: "oregon_fanpass",
  TEAM_FULL_NAME: "Oregon Ducks",
  BROWSER_TITLE: "Oregon Football Fan Pass",
  CLIENT_ID: "97787f339f16.seasonshare.oregonducks-oregonducks.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#154733",
    COLORS_SECONDARY: "#FEE123",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      BACKGROUND_COLOR: "#154733",
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLED_PAYMENT_METHODS: ["AE"],
    },

    ADD_DARK_OVERLAY: true,
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://s3.us-east-2.amazonaws.com/ss-leagues/NCAA/oregon-ducks.png",
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
